<div [@slide] class="impact-docker {{config?.theme}}">
  <div class="container content">
    <i *ngIf="icon" class="material-icons">redeem</i>
    <span class="title">{{text}}</span>
    <button *ngIf="isDonated" (click)="events()" mat-raised-button>{{btnLabel}}</button>
    <app-donate-now *ngIf="!isDonated" [label]="btnLabel"  [position]="9" [updateId]="updateId"></app-donate-now>
    <!-- <button *ngIf="!isDonated" routerLink="/new/payment" [queryParams]="{id: vars?.fundraiser?.id, type: 'full', or: 'f', ct: vars?.fundraiser?.custom_tag, payment: 'form'}" mat-raised-button>{{btnLabel}}</button> -->
  </div>
</div>